module.exports = __webpack_public_path__ + "img/3d_design.80b0a7a5.png";